interface Props {
  online: boolean
}

export function StatusDot({ online }: Props) {
  return (
    <div className="flex items-center gap-2">
      <div className={`w-2 h-2 rounded-full ${online ? 'bg-ok' : 'bg-err'}`} />
      <span className="text-xs text-sub">{online ? 'Live' : 'Offline'}</span>
    </div>
  )
}
